import React from "react";
import { Chip } from "@mui/material";

const CustomChip = ({ label, color, background }) => {
  return (
    <Chip
      label={label}
      size="small"
      style={{
        margin: "2px",
        color: color ? color : "black",
        backgroundColor: background ? background : "#e0e0e0",
      }}
    />
  );
};

export default CustomChip;
